import React, { useEffect, useState } from 'react'
import * as cookies from '../../../utilties/cookies'
import { compose, shallowEqual } from 'recompose'
import { connect, useDispatch, useSelector } from 'react-redux'
import { getCase, getIsCircleTermsAccepted } from '../../../redux/actions'
import { caseSelector, isCircleTermsAcceptedSelector } from '../../../redux/selectors'
import SurveyForm from './SurveyForm'
import { Grid } from '@material-ui/core'
import HeaderEmpty from '../../../components/HeaderEmpty'
import StyledWrapper from '../../../components/StyledWrapper'
import history from '../../../utilties/history'
import browserHistory from '../../../utilties/browserHistory'
import { useParams } from "react-router"


const Survey = ({ loadCase, data }) => {
	const [ patient ] = useState(cookies.get('user'))
	const dispatch = useDispatch()
	const isCircleTermsAccepted = useSelector(isCircleTermsAcceptedSelector, shallowEqual)

	let params = useParams()

	useEffect(() => {
		if (patient && !data) {
			loadCase(patient.id, params.caseId)
		}
		if (!!patient?.id && !!patient?.termsAccepted) {
			dispatch(getIsCircleTermsAccepted(patient.id))
		}
	}, [])
	
	useEffect(
		() => {
			if (isCircleTermsAccepted == false) {
				history.push(`/newTerms?returnUrl=${browserHistory.location.pathname}`)
			}
		},
		[isCircleTermsAccepted]
	)

	return (
		<Grid data-testid="survey-index" className="survey-index" style={{
			backgroundImage: `url(../../../../../../images/group.png)`,
			backgroundRepeat: 'no-repeat',
			backgroundColor: '#E2F1FE',
			backgroundSize: 'contain',
			backgroundPosition: 'top center',
			minHeight: '100vh'
		}}>
			<StyledWrapper hidePagesMenu={true}>
				{
					//<HeaderEmpty data-testid="survey-index-header" />
				}
				{
					isCircleTermsAccepted
					&& <SurveyForm data-testid="survey-index-form"/>
				}
			</StyledWrapper>
		</Grid>
	)
}

const mapStateToProps = (state, ownProps) => ({
	data: caseSelector(state)
})

const mapDispatchToProps = (dispatch, ownProps) => ({
	loadCase: (patientId) => dispatch(getCase(patientId))
})

const enhance = compose(connect(mapStateToProps, mapDispatchToProps))

export default enhance(Survey)
